<script lang="ts" setup></script>
<template>
  <main class="page-wide columns">
    <section class="column">
      <ul>
        <li>Ingredient</li>
        <li>Edit option</li>
        <li>Used in which dishes</li>
      </ul>

      <Ingredient></Ingredient>
    </section>
    <section class="column">
      <IngredientForm></IngredientForm>
    </section>
  </main>
</template>
